import { h } from 'preact'
interface Props {
  parentCustomClass?: string,
  childCustomClass?: string
}
export const Loader = ({ parentCustomClass, childCustomClass } : Props) => (
  <div className={`loader-container ${parentCustomClass ?? ''}`}>
    <div className={`spinner ${childCustomClass ?? ''}`} />
  </div>
)
